import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box } from 'reflexbox/styled-components'

import Section from 'components/page/Section'
import PostGrid from 'components/blog/PostGrid'

import GiantFooterTopAsset from './assets/GiantFooterTopAsset'
import MobileDesktopFooterBottomAsset from './assets/MobileDesktopFooterBottomAsset'
import MobileFooterTopAsset from './assets/MobileFooterTopAsset'
import TabletDesktopFooterTopAsset from './assets/TabletDesktopFooterTopAsset'
import TabletGiantFooterBottomAsset from './assets/TabletGiantFooterBottomAsset'

const GridContainer = styled(Box).attrs({
  mt: [60],
  mb: [120, 120, 80],
})``

const Title = styled.h2`
  max-width: 80%;
`

const Subtitle = styled(Box).attrs({
  width: [1, 0.5],
  mt: [36],
})``

export default function SectionWithAssets ({
  title,
  subtitle,
  posts,
  cardComponent,
  columns,
  baseSlug,
  tag,
  pageAmount,
  postsCentered,
  ...others
}) {
  return (
    <Section {...others}>
      <Title>{title}</Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
      <GridContainer>
        <PostGrid
          allPosts={posts}
          postComponent={cardComponent}
          columns={columns}
          baseSlug={baseSlug}
          pagination={{
            pageAmount,
            currentPageNumber: 0,
            isStateful: true,
          }}
          scrollName="help-allPosts"
          tag={tag}
          postsCentered={postsCentered}
        />
      </GridContainer>
      <GiantFooterTopAsset />
      <MobileDesktopFooterBottomAsset />
      <MobileFooterTopAsset />
      <TabletDesktopFooterTopAsset />
      <TabletGiantFooterBottomAsset />
    </Section>
  )
}
SectionWithAssets.defaultProps = {
  pageAmount: 3,
}

SectionWithAssets.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  posts: PropTypes.array.isRequired,
  columns: PropTypes.number,
  otherPosts: PropTypes.array.isRequired,
  baseSlug: PropTypes.string.isRequired,
  cardComponent: PropTypes.node.isRequired,
  tag: PropTypes.string.isRequired,
  pageAmount: PropTypes.number,
}
